import React from "react";
import Label from "../ui-components/Label";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/solid";
import Button from "../ui-components/Button";
import getOptionName from "../utils/getOptionName";
import MoveBlock from "./MoveBlock";

const ServiceConfiguratorBlockInputOption = ({
  inputId,
  data,
  createAndFetchNewElement,
  setOpenSecondBlock,
  openSecondBlock,
  deleteAndFetch,
  moveBlock,
  editable = false,
}) => {
  const optionList = data.filter((d) => d.input_id === inputId);

  return (
    <div className="flex w-full flex-col mb-4">
      <Label disabled={!editable}>Options</Label>
      <div className="mb-2" />
      {optionList.map((option, index) => {
        const active = option.id === openSecondBlock ? "bg-gray-200" : "";
        const product = option.product || null;
        let name = getOptionName(option, product);
        return (
          <div
            key={option.id}
            className={`flex w-full justify-between items-center rounded border border-gray mt-2 mb-2 p-1.5 ${active}`}
          >
            <div className="flex items-center">
              {editable && <MoveBlock
                listLength={optionList.length}
                moveBlock={moveBlock}
                position={index}
                block={option}
              />}
              <div>
                <p>{name}</p>
              </div>
            </div>
            <div className="flex ">
              <div
                onClick={() => {
                  setOpenSecondBlock(option.id);
                }}
                className="w-7 h-7 mr-2 cursor-pointer text-gray-400"
              >
                <PencilIcon />
              </div>
              <div
                onClick={() => {
                  if(editable)
                    deleteAndFetch(option.id)
                }}
                className={`w-7 h-7 ${editable? 'cursor-pointer':'cursor-not-allowed'} text-red-600`}
              >
                <TrashIcon />
              </div>
            </div>
          </div>
        );
      })}
      <div className="flex w-full justify-end mt-4">
        <Button
          onClick={() => {
            createAndFetchNewElement({
              type: "option",
              order: optionList.length,
              // step_id: block.id,
              active: true,
              input_id: inputId,
            });
          }}
        >
          ADD OPTION
        </Button>
      </div>
    </div>
  );
};

export default ServiceConfiguratorBlockInputOption;
